import React, { useState } from "react";
import "../style/buyCryptoPage.css";

const BuyCryptoPage = () => {
  const [amount, setAmount] = useState(50);
  const [mode, setMode] = useState("buy");
    return (
    <section className="buy-header">
      {/* LEFT CONTENT */}
      <div className="buy-left">
        <h1 className="buy-title">
          BUY <br /> AND SELL <br /> CRYPTO
        </h1>

        <p className="buy-subtitle">
          Turn your cash into crypto with recognised global providers. Try DeFi
          and jump into web3.
        </p>

        <button className="buy-btn">GET STARTED</button>
      </div>

      {/* RIGHT CARD */}
      <div className="buy-right">
<div className="buy-card">
  {/* TABS */}
  <div className="tabs">
    <span
      className={mode === "buy" ? "active" : ""}
      onClick={() => setMode("buy")}
    >
      Buy
    </span>

    <span
      className={mode === "sell" ? "active" : ""}
      onClick={() => setMode("sell")}
    >
      Sell
    </span>
  </div>

  {/* BUY MODE */}
  {mode === "buy" && (
    <>
      <div className="amount">
        <h2>
          ${amount} <span>USD</span>
        </h2>
      </div>

      <div className="quick-amounts">
        <button onClick={() => setAmount(50)}>$50</button>
        <button onClick={() => setAmount(100)}>$100</button>
        <button onClick={() => setAmount(250)}>$250</button>
        <button onClick={() => setAmount(500)}>$500</button>
        <button onClick={() => setAmount(1000)}>$1000</button>
      </div>

      <div className="dropdown">
        <div>
          <small style={{ display: "block", fontSize: "10px", color: "#666" }}>
            Ethereum
          </small>
          Linea
        </div>
        <span>▼</span>
      </div>

      <label className="input-label">Selected payment method</label>
      <div className="dropdown">
        Debit or credit <span>▼</span>
      </div>

      <label className="input-label">Select account</label>
      <div className="dropdown">
        metamask.linea.eth <span>▼</span>
      </div>

      <button className="buy-token">Buy token</button>
    </>
  )}

  {/* SELL MODE */}
  {mode === "sell" && (
    <>
      <div className="amount">
        <h2>
          {amount} <span>ETH</span>
        </h2>
      </div>

      <label className="input-label">Receive</label>
      <div className="dropdown">
        USD <span>▼</span>
      </div>

      <label className="input-label">From wallet</label>
      <div className="dropdown">
        metamask.linea.eth <span>▼</span>
      </div>

      <button className="buy-token sell">Sell token</button>
    </>
  )}
</div>
      </div>
    </section>
  );
};

export default BuyCryptoPage;
